export default function Home() {
  return (
    <main>
      <h2>404 Not Found</h2>
      Page is not existed
    </main>
  );
}
